import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Menu } from 'primereact/menu';
import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { InputComponent } from '../../components/InputComponent';
import { TablaDinamica } from '../../components/TablaDinamica';
import { useLazyParams } from '../../hooks/useLazyParams';
import { Declarante } from '../../models/Declarante';
import { CatalogoService } from '../../service/CatalogoService';
import { DeclaranteService } from '../../service/DeclaranteService';
import { confirmDialog } from 'primereact/confirmdialog';
import * as generic from '../../components/Generico';

export const RepresentanteApoderado = ({ toast, tipo, id, permss, tipoFrmEmpresa, soloLectura }) => {

    const esTipoEspecial = ['FRM_TOYOTA', 'FRM_DIFARE'].includes(tipoFrmEmpresa);
    const omodel = new Declarante();
    const defaultValues = generic.funDefault(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, clearErrors, getValues } = useForm({ defaultValues, shouldTrim: true, mode: 'onTouched' });
    const declaranteService = new DeclaranteService();
    const catalogoSrv = new CatalogoService();
    const [dialogDeclarante, setDialogDeclarante] = useState(false);
    const [catalogos, setCatalogos] = useState(null);
    const [esRuc, setEsRuc] = useState(false);
    const [esCedula, setEsCedula] = useState(false);
    const [ecuador, setEcuador] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [esEstadoCivil, setEsEstadoCivil] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const menuRef = useRef(null);
    const tablaDeclarantes = useLazyParams({ modelo: omodel.model });
    const [esCasado, setEsCasado] = useState(false);
    const { inDrop, inText, inArea, inCalendar } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyDeclarante();
        // eslint-disable-next-line
    }, [tablaDeclarantes.lazyParams, id]);

    const loadLazyDeclarante = () => {
        tablaDeclarantes.setLoading(true);
        const _params = { ...tablaDeclarantes.lazyParams, idp: id, tipo: tipo };
        declaranteService.getRepresentanteApoderado({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaDeclarantes.setTotalRecords(res.data.total);
            tablaDeclarantes.setData(res.data.registros);
        }).finally(() => tablaDeclarantes.setLoading(false));
    }

    const openNew = () => {
        if (catalogos == null) {
            declaranteService.newRepresentanteApoderado({ iniciar: 1, tipo: tipo, tipoFrmEmpresa: tipoFrmEmpresa }).then(res => {
                setCatalogos(res.data);
                setDialogDeclarante(true);
                setEsCasado(false);
                reset(defaultValues);
            });
        }
        else {
            setDialogDeclarante(true);
            setEsCasado(false);
            reset(defaultValues);
        }
    }

    const hideDialog = () => { setDialogDeclarante(false) }

    const onSubmit = (data) => {
        data.idp = id;
        data.tipo = tipo;
        data.ruc = catalogos.ruc;
        data.tipo = tipo;
        data.casado = catalogos.casado;
        data.union = catalogos.union;
        data.ec = catalogos.ecuador;
        data.tipoFrmEmpresa = tipoFrmEmpresa;
        data.fecha_nacimiento = generic.dateToString(data.fecha_nacimiento);

        const request = getValues('id') == null
            ? declaranteService.newRepresentanteApoderado(data)
            : declaranteService.editarDeclarante(data);
        request.then(res => {
            setDialogDeclarante(false);
            loadLazyDeclarante();
            generic.funcSuccess(res, toast);
        }).catch(error => generic.funcError(error, toast, setError));
    }

    const editFicha = (data) => {
        const iniciar = catalogos == null ? 1 : 0;
        declaranteService.consultarJuridica(data.id, tipo, id, iniciar, { tipoFrmEmpresa: tipoFrmEmpresa }).then(res => {
            let _cat = catalogos;
            if (iniciar === 1) {
                _cat = res.data.catalogos;
                setCatalogos(res.data.catalogos);
            }
            let _dec = res.data.declarante;

            if (res.data.ciudades) {
                setCiudades(res.data.ciudades);
            }
            setEsCasado(_dec?.totalConyugue > 0);
            setEcuador(_dec.pais.cat_id === _cat.ecuador.cat_id);
            setEsEstadoCivil(['clientepj', 'juridica'].includes(tipo) && ['PRO_APODERADO', 'PRO_REP_LEGAL', 'PRO_BEN_FIN'].includes(_dec.tipo_declarante?.nemonico));

            if (_dec.fecha_nacimiento) { _dec.fecha_nacimiento = generic.stringToDate(_dec.fecha_nacimiento); }
            setEsRuc(_dec.tipo_identificacion?.cat_id === _cat?.ruc?.cat_id);
            setEsCedula(_dec.tipo_identificacion?.cat_id === _cat?.cedula?.cat_id);
            reset(generic.renewValues(_dec, omodel.model));
            setDialogDeclarante(true);
        });
    }

    const confirmDelete = (data) => {
        confirmDialog({
            message: '¿Está seguro de eliminar el declarante?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminarDeclarante(data)
        });
    }

    const eliminarDeclarante = (data) => {
        declaranteService.eliminarDeclarante(data.id, tipo, id).then(res => {
            loadLazyDeclarante();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const onChangePais = (e) => {
        setEcuador(JSON.stringify(e.value) === JSON.stringify(catalogos.ecuador));
    }

    const onChangeProvincia = (e) => {
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => {
            setCiudades(res.data);
        });
    }

    const onChangeTipo = (e) => {
        setEsRuc(e.value?.cat_id === catalogos?.ruc?.cat_id);
        setEsCedula(e.value?.cat_id === catalogos?.cedula?.cat_id);
        clearErrors('identificacion');
    }

    const tipoDoc = esRuc ? 'IDEN_RUC' : esCedula ? 'IDEN_CEDULA' : null;

    const reglaValidacion = (val) => {
        if (!tipoDoc) return true;
        return generic.validarIdentificacionEcuador(val, tipoDoc) || `${esRuc ? 'RUC' : 'Cédula'} incorrecto`;
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{ label: 'Opciones', items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editFicha(registroSeleccionado) }] }];
        }

        const items = [];
        if (permss?.actualizar) {
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editFicha(registroSeleccionado) });
        }
        if (permss?.eliminar) {
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado) });
        }
        return [{ label: 'Opciones', items: items }];
    };

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu_representante" aria-haspopup onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }} />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Representantes Legales / Apoderados
            </span>
        </div>
    );

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangeTipoDeclarante = (e) => {
        setEsEstadoCivil(['PRO_APODERADO', 'PRO_REP_LEGAL', 'PRO_BEN_FIN'].includes(e.value?.nemonico));
    }

    return (
        <>
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_representante" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaDeclarantes} datos={tablaDeclarantes.data} totalRegistros={tablaDeclarantes.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogDeclarante} header={soloLectura ? "Ver información" : (getValues('id') == null ? "Nueva información" : "Editar información")} modal className="p-fluid modal-ssize" style={{ width: '800px', maxWidth: '95vw' }} onHide={e => setDialogDeclarante(false)}>
                <form onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="formgrid grid">
                        <div className="col-12 mb-2">
                            <span className="text-800 font-bold text-base flex align-items-center gap-2">
                                <i className="pi pi-id-card text-primary"></i>
                                REPRESENTANTE LEGAL / APODERADO
                            </span>
                            <div className="border-top-1 border-300 mt-2"></div>
                        </div>
                        {inDrop('tipo_declarante', catalogos?.tipoRA, { lab: omodel.optionLabel, chn: onChangeTipoDeclarante }, 4)}
                        {inDrop('tipo_identificacion', catalogos?.tipo, { lab: omodel.optionLabel, chn: onChangeTipo }, 4)}
                        {inText('identificacion', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 4)}
                        <div className="col-12 mt-3 mb-2">
                            <span className="text-700 font-bold text-sm flex align-items-center gap-2">
                                <i className="pi pi-user text-primary"></i>
                                DATOS PERSONALES
                            </span>
                            <div className="border-top-1 border-300 mt-2"></div>
                        </div>
                        {esRuc ? (
                            inText('razon_social', { icon: 'pi pi-briefcase' }, 12)
                        ) : (
                            <>
                                {inText('nombres', { icon: 'pi pi-user' }, 6)}
                                {inText('apellidos', { icon: 'pi pi-user-edit' }, 6)}
                            </>
                        )}
                        {inCalendar('fecha_nacimiento', {}, esEstadoCivil ? 3 : 4)}
                        {inDrop('nacionalidad', catalogos?.nacionalidad, { lab: omodel.optionLabel }, esEstadoCivil ? 3 : 4)}
                        {inDrop('genero', catalogos?.genero, { lab: omodel.optionLabel }, esEstadoCivil ? 3 : 4)}
                        {esEstadoCivil && inDrop('estado_civil', catalogos?.estado_civil, { lab: omodel.optionLabel, ne: esCasado ? 'disabled' : false }, 3)}
                        <div className="col-12 mt-3 mb-2">
                            <span className="text-700 font-bold text-sm flex align-items-center gap-2">
                                <i className="pi pi-map-marker text-primary"></i>
                                UBICACIÓN
                            </span>
                            <div className="border-top-1 border-300 mt-2"></div>
                        </div>
                        {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: false }, ecuador ? 4 : 6)}
                        {ecuador ? (
                            <>
                                {inDrop('provincia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: false }, 4)}
                                {inDrop('ciudad', ciudades, { lab: omodel.optionLabel }, 4)}
                            </>
                        ) : (
                            inText('canton', { icon: 'pi pi-map-marker' }, 6)
                        )}
                        {inArea('direccion_domicilio', 3, 30, 12)}
                        <div className="col-12 mt-3 mb-2">
                            <span className="text-700 font-bold text-sm flex align-items-center gap-2">
                                <i className="pi pi-phone text-primary"></i>
                                TELÉFONOS DE CONTACTO
                            </span>
                            <div className="border-top-1 border-300 mt-2"></div>
                        </div>
                        {inText('telefono_celular', { icon: 'pi pi-mobile' }, esTipoEspecial ? 6 : 4)}                        
                        {inText('telefono_fijo', { icon: 'pi pi-phone' }, 6)}

                    </div>

                    <div className="flex justify-content-end mt-4">
                        {soloLectura ? (
                            <Button label="Cerrar" icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                        ) : (
                            generic.buttonsForms(hideDialog)
                        )}
                    </div>
                </form>
            </Dialog>
        </>
    );
}